module.exports = __webpack_public_path__ + "img/stat-icon-3.2fb53fbd.png";